module.exports = __webpack_public_path__ + "img/antes_despues_156.600c354f.png";